/**
 * CODE_COMMENTS_131
 */
import { Modal } from 'semantic-ui-react'

import createComponentWithCatastrophicFailureErrorBoundary from './createComponentWithCatastrophicFailureErrorBoundary'

export default createComponentWithCatastrophicFailureErrorBoundary(Modal)
